module.exports = __webpack_public_path__ + "static/img/metal21.aa16a3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metal21.jpg
// module id = eFHI
// module chunks = 0